__turbopack_context__.v({
  "root": "Flame-module__WQWOjG__root",
});
